import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3ec3453b&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=3ec3453b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec3453b",
  null
  
)

export default component.exports